// extracted by mini-css-extract-plugin
export default {"nextButton":"M8LoeE","inputArea":"eYx66o"};